module.exports = __webpack_public_path__ + "img/brush.fd8dc702.svg";